import { render, staticRenderFns } from "./incomeTaxDeclarationPlan.vue?vue&type=template&id=44d65c6e&scoped=true"
import script from "./incomeTaxDeclarationPlan.vue?vue&type=script&lang=js"
export * from "./incomeTaxDeclarationPlan.vue?vue&type=script&lang=js"
import style0 from "./incomeTaxDeclarationPlan.vue?vue&type=style&index=0&id=44d65c6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d65c6e",
  null
  
)

export default component.exports